"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Dot = function Dot(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    height: 24,
    width: 24
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M8.465 8.465A4.984 4.984 0 0112 7c2.76 0 5 2.24 5 5 0 1.38-.56 2.63-1.465 3.535A4.984 4.984 0 0112 17c-2.76 0-5-2.24-5-5 0-1.38.56-2.63 1.465-3.535z"
  }));
};

var _default = (0, _react.forwardRef)(Dot);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Dot, "Dot", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dot.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dot.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9Eb3QudHN4Il0sIm5hbWVzIjpbIkRvdCIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxHQUFtRSxHQUFHLFNBQXRFQSxHQUFzRSxDQUFDQyxLQUFELEVBQVFDLEdBQVIsRUFBZ0I7QUFDMUYsU0FDRTtBQUFLLElBQUEsT0FBTyxFQUFDLFdBQWI7QUFBeUIsbUJBQVksTUFBckM7QUFBNEMsSUFBQSxNQUFNLEVBQUUsRUFBcEQ7QUFBd0QsSUFBQSxLQUFLLEVBQUU7QUFBL0QsS0FBdUVELEtBQXZFO0FBQThFLElBQUEsR0FBRyxFQUFFQztBQUFuRixNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQURGO0FBUUQsQ0FURDs7ZUFXZSx1QkFBV0YsR0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVhUQSxHIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBEb3Q6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnIHZpZXdCb3g9XCIwIDAgMjQgMjRcIiBhcmlhLWhpZGRlbj1cInRydWVcIiBoZWlnaHQ9ezI0fSB3aWR0aD17MjR9IHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgICAgPHBhdGhcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAgIGQ9XCJNOC40NjUgOC40NjVBNC45ODQgNC45ODQgMCAwMTEyIDdjMi43NiAwIDUgMi4yNCA1IDUgMCAxLjM4LS41NiAyLjYzLTEuNDY1IDMuNTM1QTQuOTg0IDQuOTg0IDAgMDExMiAxN2MtMi43NiAwLTUtMi4yNC01LTUgMC0xLjM4LjU2LTIuNjMgMS40NjUtMy41MzV6XCJcbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKERvdCk7XG4iXX0=